import { render, staticRenderFns } from "./withdrawManage.vue?vue&type=template&id=ccf5f956&"
import script from "./withdrawManage.vue?vue&type=script&lang=js&"
export * from "./withdrawManage.vue?vue&type=script&lang=js&"
import style0 from "./withdrawManage.vue?vue&type=style&index=0&id=ccf5f956&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports